import React from 'react'
import { Container } from 'src/components/common/Container'
import { ReactHookFc, ReactHookForm } from 'src/components/common/ReactHookForm'
import styled, { css } from 'styled-components'
import { Noto_body2_m14, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { layoutMaxSize, mediaMaxWidth } from 'src/styles/mixin'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import useLoginDetector from 'src/hooks/useLoginDetector.hook'
import { SmallDivider } from 'src/components/common/Divider'
import { SelfRegUpdatePageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponUpdatePage/index'
import SelfRegCommonFormItems from 'src/pages/SelfRegCouponPage/_components/SelfRegCommonFormItems'
import SelfRegUpdateController from 'src/pages/SelfRegCouponPage/SelfRegCouponUpdatePage/_components/SelfRegUpdateController'
import { useFormContext } from 'react-hook-form'
import { SelfRegisterCouponFormItemsType } from 'src/types/react-hook-form'

const SelfRegCouponUpdatePageView = (props: SelfRegUpdatePageProps) => {
  const { registerAttribute, selfRegCouponUpdateHandler } = props
  const { handleSubmit, formState } = useFormContext<SelfRegisterCouponFormItemsType>()
  const { isValid } = formState
  const { isLogin } = useLoginDetector()
  const { useFlag } = registerAttribute

  return (
    <S.SelfRegContainer $option="flex_column_space_between">
      <ReactHookForm style={S.SelfRegFormWrap}>
        <SelfRegUpdateController {...props} />
        <Container $option="flex_column" $row_gap="20px" $style={S.SelfRegTextInputWrap}>
          <Container $option="flex_column">
            <S.FormItemTitle $text="사용여부" />
            <Container $option="flex_row" $style={S.SelfRegUseFlagWrap}>
              <ReactHookFc.CheckBox {...useFlag} />
              <Typography $fontStyle={Noto_subheading_b18}>사용완료</Typography>
            </Container>
          </Container>
          <SelfRegCommonFormItems {...props} />
        </Container>
      </ReactHookForm>
      <SmallDivider />
      <S.SelfRegFormBottomContents $option="flex_row">
        <Button
          option={ButtonOption3('active')}
          disabled={!isLogin || !isValid}
          onClickFn={handleSubmit(selfRegCouponUpdateHandler)}
        >
          수정하기
        </Button>
      </S.SelfRegFormBottomContents>
    </S.SelfRegContainer>
  )
}
export default SelfRegCouponUpdatePageView

const S = {
  SelfRegContainer: styled(Container)`
    padding-bottom: 68px;
    flex: 1;
  `,
  SelfRegFormWrap: css`
    display: flex;
    flex-direction: column;
  `,

  SelfRegTextInputWrap: css`
    width: calc(100% - 80px);

    ${mediaMaxWidth('499')} {
      width: calc(100% - 40px);
    }

    margin: 30px auto 0 auto;
    padding-bottom: 50px;
  `,

  FormItemTitle: styled.span<{ $text: string }>`
    ${Noto_body2_m14};
    color: var(--black-50);

    &:before {
      content: '${(props) => props.$text}';
    }
  `,
  SelfRegFormBottomContents: styled(Container)`
    ${layoutMaxSize};
    gap: 10px;
    padding: 10px;
    position: fixed;
    bottom: 0;
    background-color: var(--white);
    z-index: 2;
  `,

  SelfRegUseFlagWrap: css`
    border-radius: 12px;
    background-color: var(--black-4);
    height: 72px;
    align-items: center;
    gap: 14px;
    padding: 20px 16px;
  `,
}
